import "./DropdownComponent.scss";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { getRouterForSection, routesMap } from "../../routes";
import { useEffect } from "react";

/**
 * @function DropdownComponent
 * @param etichetta the menu's name 
 * @param voci the menu's items
 * @returns {JSX.Element}
*/
const DropdownComponent = ({ etichetta, voci, openMenu, setOpenMenu, index, last, tipologia}) => { 

    const { pathname, state } = useLocation();

    useEffect(() => {
        setOpenMenu(-1);
    }, [pathname, state, setOpenMenu]);

    const openCloseMenu = () => {
        if (openMenu === index)
            setOpenMenu(-1);
        else
            setOpenMenu(index);
    }

    const checkActiveElement = () => {
        const el = document.getElementById(etichetta);
        if (el.matches(':focus-visible'))
            openCloseMenu();
    }

    return (
        <div className="dropdown">
                <Link
                    to={ getRouterForSection(tipologia)}
                    className="btn btn-dropdown dropdown__button">
                    { etichetta }
                </Link>
            <button className="btn btn-dropdown dropdown-toggle dropdown__button" id={ etichetta } type="button" onClick={ () => checkActiveElement() } role="menu" aria-label={ etichetta } aria-expanded={ openMenu === index ? "true" : "false" }>
                <div className="col-2 icon-expand icon icon-sm icon-primary material-icons-outlined" aria-hidden="true">expand_more</div>
            </button>
            { voci.length >= 1 ?
                <div className={ openMenu === index ? "dropdown-menu scrollable-menu show" : "dropdown-menu scrollable-menu" } style={ last ? { right: "0" } : {} } aria-labelledby="dropdownMenuLink">
                    {
                        voci.map(item => {
                            const { nome, idContenuto } = item;
                            return (
                                <Link key={ nome }
                                    className="dropdown-item list-item"
                                    to={ `${routesMap.DETAGLIO_CATEGORIA}/${idContenuto}`}
                                    rel={ `rel${ nome }` }
                                    onClick={ () => setOpenMenu(-1) }
                                    type="button" tabIndex="0" role="link" >
                                    <span>{ nome }</span>
                                </Link>
                            );
                        })
                    }
                </div> : <></> }
        </div>
    );
};

DropdownComponent.propTypes = {
    etichetta: PropTypes.string.isRequired,
    voci: PropTypes.array.isRequired,
};

DropdownComponent.defaultProps = {
    etichetta: "",
    voci: [],
};

export default DropdownComponent;